import apiClient from './client';

export interface ProductRuleCondition {
  field: string;
  operator: string;
  value: unknown;
}

export interface ProductRuleTarget {
  urn?: string;
  category?: string;
}

export interface ProductRule {
  urn: string;
  uuid: string;
  name: string;
  description?: string;
  enabled: boolean;
  weight: number;
  conditions: ProductRuleCondition[];
  conditionGroup?: {
    operator: string;
    conditions: ProductRuleCondition[];
  };
  targets: ProductRuleTarget[];
  elseTargets?: ProductRuleTarget[];
  creationDate: string;
  modificationDate: string;
}

export interface CreateProductRuleRequest {
  name: string;
  description?: string;
  enabled: boolean;
  weight: number;
  conditions: ProductRuleCondition[];
  targets: ProductRuleTarget[];
  elseTargets?: ProductRuleTarget[];
}

export async function getProductRules(): Promise<ProductRule[]> {
  const response = await apiClient.get('/rules');
  return response.data;
}

export async function getProductRule(urn: string): Promise<ProductRule> {
  const response = await apiClient.get(`/rules/${urn}`);
  return response.data;
}

export async function createProductRule(data: CreateProductRuleRequest): Promise<ProductRule> {
  const response = await apiClient.post('/rules', data);
  return response.data;
}

export async function updateProductRule(
  urn: string,
  data: Partial<CreateProductRuleRequest>,
): Promise<ProductRule> {
  const response = await apiClient.put(`/rules/${urn}`, data);
  return response.data;
}
